var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head outer",class:{'is-offset': _vm.offset, 'has-actions': _vm.$route.meta.hasActions, 'is-fixed': _vm.fixed}},[_c('div',{staticClass:"head-inner inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }